import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Variáveis de ambiente do Supabase não configuradas');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Tipos para o banco de dados
export interface Manifestacao {
  id: string;
  titulo: string;
  descricao: string;
  categoria: string;
  prioridade: string;
  status: string;
  cidade: string;
  bairro: string;
  endereco: string;
  latitude?: number;
  longitude?: number;
  author_id?: string;
  author_name?: string;
  author_email?: string;
  created_at: string;
  updated_at: string;
  anexos?: string[];
  tags?: string[];
}

export interface User {
  id: string;
  email: string;
  role: 'admin' | 'user';
  name?: string;
  created_at: string;
}
